import { useAppPersistenceStore } from '@ninjacart/nc-nk-store';
import { Paragraph, SizableText, Text } from 'tamagui';

export const TextWrapper = (props) => {
  const { children, trimValue = 0.8, languaguesToTrim = [], styles, ...rest } = props;
  const appLanguage = useAppPersistenceStore((state) => state.appLanguage);
  const needToTrim = languaguesToTrim.includes(appLanguage);
  const trimVal = needToTrim ? trimValue : 1;
  const newRestProps = {
    ...rest,
    style: needToTrim ? { flex: trimVal, ...styles } : { ...styles },
  };

  return <Text {...newRestProps}>{children}</Text>;
};
